import { types as t } from 'mobx-state-tree';

export default t.enumeration('StoreState', ['initial', 'loading', 'loaded']);
